import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { LoopBackConfig, LoopBackAuth } from '@assets/js/lb-sdk';
import { STORAGE_LOCATIONS, UPLOAD_TYPE } from '@app/enums';
import { UploadInput, UploadOutput, UploaderOptions } from 'ngx-uploader';
import { formatEvent } from '@app/helpers/upload-input-formatter' 

interface UploadForm {
  type: number;
  file?: any
};

/**
 * Changes:
 * 1. source/enums/UPLOAD_TYPE.ts
 * 2. source/enums/STORAGE_LOCATIONS.ts
 * 3. server/common/models/upload.js
 * 4. setup in payment-list component, add tabs to the html template
 * 5. add upload-form to app.module entryComponent list
 */
@Component({
  selector: 'app-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.css']
})
export class UploadFormComponent implements OnInit {
  data: UploadForm;
  loading: boolean = false;
  error: string;
  file;
  title: string = 'Payment File';
  uploadInput: EventEmitter<UploadInput> = new EventEmitter<UploadInput>();
  options: UploaderOptions = {
    concurrency: 1,
    allowedContentTypes: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
  };

  constructor(
    public modal: BsModalRef,
    private loopBackAuth: LoopBackAuth
  ) { }

  /**
   * Initialized through parent form's new(data) call
   */
  ngOnInit() {
    this.data = this.data || {
      type: UPLOAD_TYPE.PAYPAL_PAYMENTS
    };
    switch (this.data.type) {
      case UPLOAD_TYPE.PAYPAL_PAYMENTS:
        this.title = 'Paypal Payment File';
        break;
      case UPLOAD_TYPE.PAYNAMICS_PAYMENTS:
          this.title = 'Paynamics Payment File';
          this.options.allowedContentTypes = ['*']
          break;
      default:
        this.title = `File type is ${this.data.type}`;
    }
  }


  onUploadOutput(output: UploadOutput) {
    switch (output.type) {
      case 'addedToQueue':
        if (typeof output.file !== 'undefined') {
          this.error = undefined;
          this.file = output.file;
        }
        break;
      case 'start':
        this.loading = true;
        break;
      case 'rejected':
        this.data.file = undefined;
        this.file = undefined;
        this.error = "File Rejected";
        break;
      case 'done':
        setTimeout(() => {
          this.loading = false;
          if (output.file && output.file.responseStatus === 200) {
            this.modal.content.result = 'success';
            this.modal.hide();
          } else {
            this.data.file = undefined;
            this.file = undefined;
            this.error = "File Upload failed";
          }
        }, 1000);
        break
      default:
        break;
    }
  }

  dismiss(reason: string) {
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

  close(form) {
    if (form.valid) {
      if (this.data.file) {
        const path = LoopBackConfig.getPath() + '/api/AmazonS3/' + STORAGE_LOCATIONS.PAYPAL_PAYMENTS + '/upload';
        if (path && path !== '') {
          const event = formatEvent('uploadAll',path,
            this.loopBackAuth.getToken() && this.loopBackAuth.getToken().id || '', 
            { type: this.data.type.toString(), uploader: this.getUser().id }
          )
          this.uploadInput.emit(event);
        }
      }
    }
  }

}
